import React from 'react';
import PropTypes from 'prop-types';

import './FormField.css';
import 'react-select/dist/react-select.css';

import Select from 'react-select';
import { DateRangePicker } from 'react-dates';

class FormField extends React.Component {
  static propTypes = {
    nomargin: PropTypes.bool,
    type: PropTypes.string,
    name: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.any,
    options: PropTypes.array,
    errorCode: PropTypes.string,
    disabled: PropTypes.bool,
    // Optional button that will render if there is text
    button: PropTypes.string,
    // Optional button icon
    buttonIcon: PropTypes.string,
    // Disable the optional button
    buttonDisabled: PropTypes.bool,
    onChange: PropTypes.func,
    // Function hook when optional button is pressed
    onButtonClick: PropTypes.func
  };

  state = {
    // Holding variable for react-dates
    focusedInput: null
  };

  _renderInputClassName = () => {
    const { value, disabled, errorCode } = this.props;
    if (disabled) {
      return 'FormField-input-disabled';
    } else if (value && !errorCode) {
      return 'FormField-input-valid';
    } else if (value && errorCode) {
      return 'FormField-input-invalid';
    }
    return 'FormField-input-empty';
  }

  _renderError = () => {
    const { errorCode } = this.props;
    switch (errorCode) {
      case 'duplicate-code':
        return 'Code already exists. Please try another code.';
      case 'duplicate-tag':
        return 'Tag already exists.';
      default:
        return 'Unknown Error. Contact Shing.';
    }
  }

  render() {
    const {
      nomargin,
      type,
      name,
      title,
      subtitle,
      placeholder,
      value,
      options,
      disabled,
      buttonText,
      buttonIcon,
      buttonDisabled,
      errorCode,
      onChange,
      onButtonClick,
      onToggle
    } = this.props;

    return (
      <div className={nomargin ? 'FormField-root-nomargin' : 'FormField-root'}>
        { title && <p className='FormField-title'>{title}</p> }
        { 
          subtitle && <p className='FormField-subtitle'>{subtitle}</p>
        }
        {
          (type === 'text' || type === 'number') &&
          <div className='FormField-inputContainer'>
            <input
              className={this._renderInputClassName()}
              pattern={type === 'number' ? '[0-9]*' : ''}
              name={name}
              placeholder={placeholder}
              value={value}
              disabled={disabled}
              onChange={onChange}
            />
            {
              buttonText &&
              <button 
                className={(buttonDisabled || errorCode) ? 'FormField-button-disabled' : 'FormField-button'}
                type='button'
                disabled={buttonDisabled || errorCode}
                onClick={onButtonClick}
              >
                { buttonIcon ? <i className={`fa ${buttonIcon}`} /> : null }
                { buttonIcon ? ' ' : null }
                { buttonText }
              </button>
            }
          </div>
        }
        {
          type === 'textarea' &&
          <textarea
            className={this._renderInputClassName()}
            rows='8'
            name={name}
            placeholder={placeholder}
            value={value}
            disabled={disabled}
            onChange={onChange}
          />
        }
        {
          type === 'select' &&
          <Select
            name={name}
            clearable={false}
            placeholder={placeholder}
            value={value}
            disabled={disabled}
            onChange={onChange}
            options={options}
          />
        }
        {
          type === 'tag' &&
          <Select.Creatable
            name={name}
            placeholder={placeholder}
            value={value}
            disabled={disabled}
            onChange={onChange}
            options={options}
          />
        }
        {
          type === 'daterange' &&
          <DateRangePicker
            startDateId='startDate'
            startDate={value.startDate}
            endDateId='endDate'
            endDate={value.endDate}
            onDatesChange={onChange}
            isOutsideRange={() => false}
            focusedInput={this.state.focusedInput}
            onFocusChange={focusedInput => this.setState({ focusedInput })}
          />
        }
        {
          type === 'checkbox' &&
          <div className='FormField-checkBox'>
            <input
              id={`checkbox-${name}`}
              type='checkbox'
              name={name}
              value={value}
              onChange={onToggle}
            />
            <label htmlFor={`checkbox-${name}`}>
              {
                value === true &&
                <i className='fa fa-check' />
              }
            </label>
          </div>
        }
        {
          errorCode &&
          <p className='FormField-errorText'>
            { this._renderError() }
          </p>
        }
      </div>
    );
  }
}

export default FormField;



// WEBPACK FOOTER //
// ./src/components/contentform/FormField/FormField.js